import * as React from "react";

export function SafeHydrate({ children }: { children: React.ReactNode }) {
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(() => setMounted(true), []);
    return mounted ? <>{children}</> : null; // no fallback
}
